import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);

class ActionFilter {
  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_OVERDUE_FRA() {
    return 'Overdue';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_WITHIN_FRA() {
    return 'Upcoming';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_OVERDUE_INTERNAL() {
    return 'Overdue Internal';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_WITHIN_INTERNAL() {
    return 'Upcoming Internal';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_OVERDUE_1_30() {
    return 'Overdue 1-30 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_OVERDUE_31_60() {
    return 'Overdue 31-60 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_OVERDUE_61_90() {
    return 'Overdue 61-90 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_OVERDUE_OVER_90() {
    return 'Overdue 90+ Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_WITHIN_1_30() {
    return 'Upcoming 1-30 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_WITHIN_31_60() {
    return 'Upcoming 31-60 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_WITHIN_61_90() {
    return 'Upcoming 61-90 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_WITHIN_OVER_90() {
    return 'Upcoming 90+ Days';
  }

  // workplan

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_PLAN_OVERDUE_FRA() {
    return 'Overdue Plan';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_PLAN_WITHIN_FRA() {
    return 'Upcoming Plan';
  }


  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_PLAN_OVERDUE_1_30() {
    return 'Overdue Plan 1-30 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_PLAN_OVERDUE_31_60() {
    return 'Overdue Plan 31-60 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_PLAN_OVERDUE_61_90() {
    return 'Overdue Plan 61-90 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_PLAN_OVERDUE_OVER_90() {
    return 'Overdue Plan 90+ Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_PLAN_WITHIN_1_30() {
    return 'Upcoming Plan 1-30 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_PLAN_WITHIN_31_60() {
    return 'Upcoming Plan 31-60 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_PLAN_WITHIN_61_90() {
    return 'Upcoming Plan 61-90 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_PLAN_WITHIN_OVER_90() {
    return 'Upcoming Plan 90+ Days';
  }


  // fra + workplan

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_FRA_AND_PLAN_OVERDUE_FRA() {
    return 'Overdue';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_FRA_AND_PLAN_WITHIN_FRA() {
    return 'Upcoming';
  }


  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_FRA_AND_PLAN_OVERDUE_1_30() {
    return 'Overdue 1-30 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_FRA_AND_PLAN_OVERDUE_31_60() {
    return 'Overdue 31-60 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_FRA_AND_PLAN_OVERDUE_61_90() {
    return 'Overdue 61-90 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_FRA_AND_PLAN_OVERDUE_OVER_90() {
    return 'Overdue 90+ Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_FRA_AND_PLAN_WITHIN_1_30() {
    return 'Upcoming 1-30 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_FRA_AND_PLAN_WITHIN_31_60() {
    return 'Upcoming 31-60 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_FRA_AND_PLAN_WITHIN_61_90() {
    return 'Upcoming 61-90 Days';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static FILTER_DATE_FRA_AND_PLAN_WITHIN_OVER_90() {
    return 'Upcoming 90+ Days';
  }
}

export default ActionFilter;

class Workplan {
  dateRanges = (overdueFilter, dueDate) => {
    const now = dayjs();
    switch (overdueFilter) {
      case ActionFilter.FILTER_DATE_PLAN_OVERDUE_FRA():
        return dueDate.isBefore(now, 'day');
      case ActionFilter.FILTER_DATE_PLAN_OVERDUE_1_30():
        return dueDate.isBetween(now.subtract(30, 'day'), now, 'day');
      case ActionFilter.FILTER_DATE_PLAN_OVERDUE_31_60():
        return dueDate.isBetween(now.subtract(60, 'day'), now.subtract(31, 'day'), 'day');
      case ActionFilter.FILTER_DATE_PLAN_OVERDUE_61_90():
        return dueDate.isBetween(now.subtract(90, 'day'), now.subtract(61, 'day'), 'day');
      case ActionFilter.FILTER_DATE_PLAN_OVERDUE_OVER_90():
        return dueDate.isBefore(now.subtract(90, 'day'), 'day');
      case ActionFilter.FILTER_DATE_PLAN_WITHIN_FRA():
        return dueDate.isSameOrAfter(now, 'day');
      case ActionFilter.FILTER_DATE_PLAN_WITHIN_1_30():
        return dueDate.isBetween(now, now.add(30, 'day'), 'day');
      case ActionFilter.FILTER_DATE_PLAN_WITHIN_31_60():
        return dueDate.isBetween(now.add(31, 'day'), now.add(60, 'day'), 'day');
      case ActionFilter.FILTER_DATE_PLAN_WITHIN_61_90():
        return dueDate.isBetween(now.add(61, 'day'), now.add(90, 'day'), 'day');
      case ActionFilter.FILTER_DATE_PLAN_WITHIN_OVER_90():
        return dueDate.isAfter(now.add(90, 'day'), 'day');
      default:
        return false;
    }
  }

  options = () => {
    return [
      ActionFilter.FILTER_DATE_PLAN_OVERDUE_FRA(),
      ActionFilter.FILTER_DATE_PLAN_OVERDUE_1_30(),
      ActionFilter.FILTER_DATE_PLAN_OVERDUE_31_60(),
      ActionFilter.FILTER_DATE_PLAN_OVERDUE_61_90(),
      ActionFilter.FILTER_DATE_PLAN_OVERDUE_OVER_90(),
      ActionFilter.FILTER_DATE_PLAN_WITHIN_FRA(),
      ActionFilter.FILTER_DATE_PLAN_WITHIN_1_30(),
      ActionFilter.FILTER_DATE_PLAN_WITHIN_31_60(),
      ActionFilter.FILTER_DATE_PLAN_WITHIN_61_90(),
      ActionFilter.FILTER_DATE_PLAN_WITHIN_OVER_90(),
    ]
  }

  mapping = () => {
    return {
      1: ActionFilter.FILTER_DATE_PLAN_OVERDUE_FRA(),
      2: ActionFilter.FILTER_DATE_PLAN_OVERDUE_1_30(),
      3: ActionFilter.FILTER_DATE_PLAN_OVERDUE_31_60(),
      4: ActionFilter.FILTER_DATE_PLAN_OVERDUE_61_90(),
      5: ActionFilter.FILTER_DATE_PLAN_OVERDUE_OVER_90(),
      6: ActionFilter.FILTER_DATE_PLAN_WITHIN_FRA(),
      7: ActionFilter.FILTER_DATE_PLAN_WITHIN_1_30(),
      8: ActionFilter.FILTER_DATE_PLAN_WITHIN_31_60(),
      9: ActionFilter.FILTER_DATE_PLAN_WITHIN_61_90(),
      10: ActionFilter.FILTER_DATE_PLAN_WITHIN_OVER_90(),
    }
  }
}

export const workPlanFilter = new Workplan();

class FRAAndWorkplanDueDates {
  dateRanges = (overdueFilter, row) => {
    const now = dayjs();
    let dueDate = dayjs(row.data.dueDate);
    let workPlanDueDate = dayjs(row.data.workPlanDueDate);      

    if ( (workPlanDueDate.isValid() && workPlanDueDate.isBefore(now, 'day') && dueDate.isSame(now, 'day')) ||
      ((workPlanDueDate.isAfter(dueDate) && dueDate.isBefore(now, 'day')) || workPlanDueDate.isAfter(now)) ) {
        dueDate = workPlanDueDate;
    }

    switch (overdueFilter) {
      case ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_FRA():
        return dueDate.isBefore(now, 'day');
      case ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_1_30():
        return dueDate.isValid() && dueDate.isBetween(now.subtract(30, 'day'), now, 'day', '[]');
      case ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_31_60():
        return dueDate.isValid() && dueDate.isBetween(now.subtract(60, 'day'), now.subtract(31, 'day'), 'day', '[]');
      case ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_61_90():
        return dueDate.isValid() && dueDate.isBetween(now.subtract(90, 'day'), now.subtract(61, 'day'), 'day', '[]');
      case ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_OVER_90():
        return dueDate.isValid() && dueDate.isBefore(now.subtract(90, 'day'), 'day');
      case ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_FRA():
        return !dueDate.isValid() || dueDate.isValid() && dueDate.isSameOrAfter(now, 'day');
      case ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_1_30():
        return dueDate.isValid() && dueDate.isBetween(now, now.add(30, 'day'), 'day', '[]');
      case ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_31_60():
        return dueDate.isValid() && dueDate.isBetween(now.add(31, 'day'), now.add(60, 'day'), 'day', '[]');
      case ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_61_90():
        return dueDate.isValid() && dueDate.isBetween(now.add(61, 'day'), now.add(90, 'day'), 'day', '[]');
      case ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_OVER_90():
        return !dueDate.isValid() || dueDate.isAfter(now.add(90, 'day'), 'day');
      default:
        return false;
    }
  }

  options = () => {
    return [
      ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_FRA(),
      ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_1_30(),
      ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_31_60(),
      ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_61_90(),
      ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_OVER_90(),
      ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_FRA(),
      ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_1_30(),
      ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_31_60(),
      ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_61_90(),
      ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_OVER_90(),
    ]
  }

  mapping = () => {
    return {
      1: ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_FRA(),
      2: ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_1_30(),
      3: ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_31_60(),
      4: ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_61_90(),
      5: ActionFilter.FILTER_DATE_FRA_AND_PLAN_OVERDUE_OVER_90(),
      6: ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_FRA(),
      7: ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_1_30(),
      8: ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_31_60(),
      9: ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_61_90(),
      10: ActionFilter.FILTER_DATE_FRA_AND_PLAN_WITHIN_OVER_90(),
    }
  }
}

export const fraAndWorkplanDueDates = new FRAAndWorkplanDueDates();